import React from "react";
import {
  FaTypo3,
  FaPencilRuler,
  FaLayerGroup,
  FaSitemap,
  FaPalette,
  FaAlignLeft,
} from "react-icons/fa";

const features = [
  { icon: <FaTypo3 />, title: "Typography" },
  { icon: <FaPencilRuler />, title: "Design Principles" },
  { icon: <FaLayerGroup />, title: "UI Design" },
  { icon: <FaSitemap />, title: "Visual Hierarchy" },
  { icon: <FaPalette />, title: "Color Theory" },
  { icon: <FaAlignLeft />, title: "White Space" },
];

const BookChapters = () => {
  return (
    <div id="how-it-works" className="w-full bg-[#f9f7f6] py-16 px-4 md:px-10">
      {/* Top Section */}

      {/* Content Section */}
      <div className="flex flex-col md:flex-row justify-center items-center gap-12">
        {/* Book Image */}
        <div className="flex-shrink-0 w-full md:w-[35%]">
          <img
            src="/sec2Img.jpeg" // Replace with actual image path
            alt="Book Cover"
            className="rounded-lg shadow-md w-full object-cover"
          />
        </div>

        {/* Features */}
        <div className=" gap-6 w-full md:w-[70%]">
          <div className="  w-full bg-[#1C1C1C] text-white p-4  mt-8 md:mt-0 shadow-lg relative z-10">
            <p className="text-sm tracking-wide text-gray-400 mb-2">
              How It Works
            </p>
            {/* <p className="text-sm text-pink-500 font-semibold uppercase tracking-widest mb-2"></p> */}
            <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-4">
              Unlock Your Book's #1 Bestseller Potential on Amazon
            </h2>
            <div className="w-12 mt-2 mb-4 h-[2px] bg-pink-400 rounded-full"></div>
            <div className="text-white mb-4">
              <h3 className="text-lg font-semibold mb-2">
                1. Smart, Customized Strategy
              </h3>
              <p>
                We understand how Amazon’s algorithm works—every 2.5 hours, they
                refresh the rankings based on what books are bringing them the
                most value. We use this to your advantage. By combining our
                proven techniques—including strategic affiliate marketing and
                powerful promotion across multiple large reader groups—we create
                a surge in visibility and sales. When the rankings refresh,
                Amazon recognizes your book as a top performer and places it
                where it belongs: #1 bestseller in your category.
              </p>
            </div>
            <div className="text-white mb-4">
              <h3 className="text-lg font-semibold mb-2">
                2. Guaranteed Bestseller Status
              </h3>
              <p>
                With our expert methods, your book will hit #1 in its category.
                We've done this many times, and we know exactly what works.
              </p>
            </div>
            <div className="text-white mb-4">
              <h3 className="text-lg font-semibold mb-2">What You Get?</h3>
              <ul className="list-disc pl-5">
                <li>Instant credibility as a bestselling author</li>
                <li>Boosted book sales and long-term discoverability</li>
                <li>
                  More media attention, reviews, and speaking opportunities
                </li>
              </ul>
            </div>
            <div className="text-white mb-4">
              <h3 className="text-lg font-semibold mb-2">Sustained Success</h3>
              <p>
                Most authors think hitting #1 is the hard part—but staying
                there? That’s even harder. Here’s the good news: With our
                system, it’s very rare for a book to hit #1 and then drop
                quickly. In fact, many books stay at the top for weeks—even
                months. But this kind of exposure doesn’t last forever… unless
                you act when the opportunity is right.
              </p>
            </div>{" "}
            {/* Divider */}
            <div className="mt-8 h-6 w-40">
              <svg
                viewBox="0 0 200 20"
                xmlns="http://www.w3.org/2000/svg"
                className="w-full h-full"
              >
                <path
                  d="M0 10 C 10 0, 20 20, 30 10 
             S 50 0, 60 10 
             S 80 20, 90 10 
             S 110 0, 120 10 
             S 140 20, 150 10 
             S 170 0, 180 10 
             S 190 20, 200 10"
                  stroke="#fff"
                  fill="transparent"
                  strokeWidth="2"
                />
              </svg>
            </div>
            <br />
            <div className="text-white mb-4">
              <p>Let’s make sure you don’t miss it.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookChapters;
